import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IPlaybackModel } from "../investigation.models";
import {
  PanelMessageStyled,
  PanelSectionStyled,
  PanelSectionTitleStyled,
} from "../investigation.panel.styled";
import { passengerSeekMs } from "../investigation.utils";
import { usePlaybackContext } from "../playback/ride-investigation-playback.context";
import { usePlaybackSnapshot } from "../playback/use-playback-snapshot";
import { InvestigationPassengerRow } from "./investigation.passenger-row";

/** The ride's passenger roster in route order; a row seeks playback to that passenger's boarding. */
export const InvestigationPassengerList: FC<{ model: IPlaybackModel }> = ({
  model,
}) => {
  const { t } = useTranslation();
  const { seekToMs } = usePlaybackContext();
  const snapshot = usePlaybackSnapshot();
  const passengers = model.payload.passengers;
  // Highlights everyone boarding at the station playback has reached, the way the station list does.
  const currentSequence = snapshot?.currentStationIndex ?? -1;

  if (!passengers?.length) {
    return (
      <PanelMessageStyled>
        {t("rideMap.investigation.passengers.empty")}
      </PanelMessageStyled>
    );
  }

  return (
    <PanelSectionStyled>
      <PanelSectionTitleStyled>
        {t("rideMap.investigation.passengers.listTitle")} · {passengers.length}
      </PanelSectionTitleStyled>
      {passengers.map(passenger => {
        const seekMs = passengerSeekMs(passenger);

        return (
          <InvestigationPassengerRow
            key={passenger.id}
            passenger={passenger}
            isActive={passenger.pickupSequence === currentSequence}
            onSeek={() => seekMs !== undefined && seekToMs(seekMs)}
          />
        );
      })}
    </PanelSectionStyled>
  );
};
